export const PreviousAddressTableColumnId = {
  FULL_ADDRESS: 'fullAddress',
  START_OF_RESIDENCE: 'startOfResidence',
  END_OF_RESIDENCE: 'endOfResidence',
  HOUSING_TYPE: 'housingType',
  MONTHLY_RENT: 'monthlyRent',
};

export const defaultPreviousAddressSortOrder = {
  direction: 'desc',
  id: PreviousAddressTableColumnId.START_OF_RESIDENCE,
};

export const MAX_PREVIOUS_ADDRESSES_COUNT = 4;

export const previousAddressModifiedFieldsToExclude = [
  'addressId',
  'applicationId',
  'companyId',
  'lastModified',
  'borrowerId',
  'orderNumber',
  'residenceId',
  'pendingChangesActionType',
  'modifiedFields',
  'fullAddress',
];
